import { CallStatus } from '../../types';
import { logger } from '../../utils/logger';
import { unlockAcwUi } from './acw-ui-lock';

export function shouldRecoverStuckPostCallState(input: {
  callStatus: CallStatus;
  agentStateName: string;
  agentInAcw: boolean;
  isRinging: boolean;
}): boolean {
  if (input.isRinging || input.agentInAcw) {
    return false;
  }

  if (input.callStatus !== 'disconnected') {
    return false;
  }

  const normalizedAgentState = input.agentStateName?.toLowerCase() ?? '';
  return normalizedAgentState === 'available' || normalizedAgentState === 'unavailable';
}

export function releasePostCallUiLocks(): void {
  unlockAcwUi();
  logger.lifecycle('[ACW Flow] released post-call UI locks');
}
